import {
	SEUIL_PROFESSIONNALISATION
} from '@/contextes/économie-collaborative'
import { Conseil, Info, Tableau, Valeur } from '@/design-system'
import { montantToString } from '@/domaine/Montant'

import { RecettesDéclarées } from './RecettesDéclarées'

export const metadata = {
	title: 'Comprendre la location de meublé courte durée',
	metaTitle: 'Documentation - Location de meublé',
	description: 'Comprendre les régimes fiscaux et sociaux de la location meublée'
}

# Location meublée : vue d'ensemble

La **location meublée** est soumise à des régimes fiscaux et sociaux spécifiques qui dépendent principalement du montant de vos recettes annuelles.

## Principe général

En tant que loueur en meublé, vous devez :
- **Déclarer vos recettes** issues de la location
- **Choisir un régime fiscal** (micro-BIC ou régime réel)
- **Cotiser au régime social** adapté à votre situation : <Valeur>{montantToString(SEUIL_PROFESSIONNALISATION.MEUBLÉ)}</Valeur>


<RecettesDéclarées />


## Seuils importants

<Tableau>
	<thead>
	<tr>
		<th>Montant des recettes</th>
		<th>Régime social</th>
		<th>Particularités</th>
	</tr>
	</thead>
	<tbody>
	<tr>
		<td>Moins de <Valeur couleur="primary">{montantToString(SEUIL_PROFESSIONNALISATION.MEUBLÉ)}</Valeur></td>
		<td>Pas de cotisations obligatoires</td>
		<td>Revenus considérés comme patrimoniaux</td>
	</tr>
	<tr>
		<td>Plus de <Valeur couleur="primary">{montantToString(SEUIL_PROFESSIONNALISATION.MEUBLÉ)}</Valeur></td>
		<td>Régime général ou micro-social</td>
		<td>Activité professionnelle</td>
	</tr>
		</tbody>
</Tableau>

<Info>
	La fiscalité suit ses propres seuils avec des plafonds différents selon le
	type de location (classique ou tourisme classé).
</Info>

<Conseil>
	Consultez les différentes sections ci-dessous pour comprendre en détail chaque
	régime et optimiser votre situation.
</Conseil>
